import React, { useEffect } from 'react';
import { Texture } from 'pixi.js'
import { Sprite, Container, withFilters } from '@inlet/react-pixi'
import { GlowFilter } from 'pixi-filters';
import HitAreaShapes from 'hitarea-shapes';
import polygons from './rainbowShape.json';

const hitAreaShapes = new HitAreaShapes(polygons);

const Filters = withFilters(Container, {
    glow: GlowFilter,
});

const Rainbow = ({ route }) => {
    const [filter, setFilter] = React.useState(0);
    let rainbowTexture = Texture.from(`./assets/images/components/island/particle/rainbow.png`);
    let campaignTexture = Texture.from(`./assets/images/components/island/particle/campaignText.png`);
    const rainBowSprite = React.useRef();

    useEffect(() => {
        loadFoodEvents();
    }, []);

    const loadFoodEvents = () => {
        if (rainBowSprite.current !== null && rainBowSprite.current !== undefined) {
            rainBowSprite.current.hitArea = hitAreaShapes;
        }
    }

    return (
        <Filters scale={1} glow={{ distance: 100, outerStrength: filter, innerStrength: filter / 4, quality: 0, color: '0xf5f5f5' }}>
            <Sprite ref={rainBowSprite} scale={{ x: 0.4, y: 0.4 }} x={250} texture={rainbowTexture}
                interactive={true} buttonMode={true}
                pointerdown={() => {
                    route()
                }}
                pointerover={() => setFilter(4)}
                pointerout={() => setFilter(0)}
            />
            <Sprite x={450} y={20} scale={{ x: 0.4, y: 0.4 }} texture={campaignTexture}
                interactive={true} buttonMode={true}
                pointerdown={() => {
                    route()
                }}
                pointerover={() => setFilter(4)}
                pointerout={() => setFilter(0)}
            />
        </Filters>
    );
};

export { Rainbow as default }